module.exports = __webpack_public_path__ + "img/writing.2bd9c1f4.svg";